/**
 * SHA-256 hex digest helper.
 *
 * Used for blend-file content hashing, library item dedupe, and reference
 * image keying. Lives outside `persistence/` because reference images and
 * library code share it without dragging in scene serialization.
 */

export async function computeFileHash(buffer: ArrayBuffer): Promise<string> {
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
  const bytes = new Uint8Array(hashBuffer);
  let hex = "";
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, "0");
  }
  return hex;
}
